import React from "react";
import PropTypes from "prop-types";
import styles from "./ChevronButton.module.css";
import classNames from "classnames";

import { ChevronRight } from "react-ikonate";

/**
 * Interactive component.
 * A button with a chevron icon.
 */
export function ChevronButton({ orientation, onClick }) {
  return (
    <div className={styles.iconDiv} onClick={onClick}>
      <span
        className={classNames(styles.chevron, {
          [styles.rotate]: orientation === "down",
        })}
      >
        <ChevronRight />
      </span>
    </div>
  );
}

ChevronButton.propTypes = {
  /**
   * String that determines the orientation of the chevron icon.
   */
  orientation: PropTypes.oneOf(["right", "down"]),
  /**
   * Function that fires when the button is clicked.
   */
  onClick: PropTypes.func,
};
